import React from 'react'
import { Button, Card, CardContent, Divider, Typography } from '@mui/material'
import { useParams } from 'react-router'
import { Helmet } from '@dr.pogodin/react-helmet'

import CustomerApi from '../../../api/CustomerApi'
import useAuth from '../../../hooks/useAuth'
import { CustomerEntity } from '../../../types/CustomerEntity'
import UserApi from '../../../api/UserApi'
import UsersGrid from '../../../components/entities/UsersGrid'
import CustomerDialog from './CustomerDialog'
import { UserEntity } from '@finance-lab/utils/types'

const customerApi = new CustomerApi()
const userApi = new UserApi()

const CustomerDetailsForm = () => {
    const { customerId } = useParams()
    const [customer, setCustomer] = React.useState<CustomerEntity | null>(null)
    const [users, setUsers] = React.useState<UserEntity[] | null>(null)
    const [customerDialogOpen, setCustomerDialogOpen] = React.useState<boolean>(false)
    const { isAuthenticated } = useAuth()

    React.useEffect(() => {
        const fetchCustomer = async () => {
            if (!isAuthenticated) return
            const response = await customerApi.getCustomer(customerId)
            setCustomer(response)
        }
        void fetchCustomer()
    }, [customerId, isAuthenticated])

    React.useEffect(() => {
        const fetchUsers = async () => {
            if (!isAuthenticated) return
            const response = await userApi.adminFindUsersForCustomer(customerId)
            setUsers(response)
        }
        void fetchUsers()
    }, [customerId, isAuthenticated])

    if (!customer) {
        return null
    }

    const handleSetUsers = (newUsers: UserEntity[]) => {
        const usersForThisCustomer = newUsers.filter((user) => user.customerId === customer.id)
        setUsers(usersForThisCustomer)
    }

    return (
        <React.Fragment>
            <Helmet title={`Kund: ${customer.name}`} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                Kund: {customer.name}
            </Typography>
            <Button
                variant='outlined'
                size='small'
                color='primary'
                sx={{ mb: 6 }}
                onClick={() => setCustomerDialogOpen(true)}
            >
                Redigera
            </Button>
            <Divider sx={{ my: 6 }} />
            <Card sx={{ mb: 6 }}>
                <CardContent>
                    <UsersGrid
                        fields={['name', 'email', 'lastActive', 'actions']}
                        users={users}
                        setUsers={handleSetUsers}
                    />
                </CardContent>
            </Card>
            <CustomerDialog
                customer={customer}
                open={customerDialogOpen}
                onClose={() => setCustomerDialogOpen(false)}
                onSubmit={async (customerData) => {
                    await customerApi.updateCustomer(customer.id, customerData)
                    setCustomer({ ...customerData, id: customer.id })
                    setCustomerDialogOpen(false)
                }}
            />
        </React.Fragment>
    )
}

export default CustomerDetailsForm
